module.exports = __webpack_public_path__ + "static/discount1-71a4906ae1479bcfe5b3a254efcc4c08.jpg";